"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TrailDocumentValue = void 0;
var _CallAPI = require("01_core/components/system/CallAPI");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _styles = require("@mui/material/styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Container = (0, _styles.styled)('div')({
  display: 'flex',
  flexWrap: 'nowrap',
  height: '100%'
});
const LabelBox = (0, _styles.styled)('div')(_ref => {
  let {
    theme
  } = _ref;
  return {
    background: theme.palette.table.header.primary.main,
    color: theme.palette.table.header.primary.contrastText,
    display: 'flex',
    padding: theme.spacing(1),
    border: 'solid 1px ' + theme.palette.border.gray,
    alignItems: 'center',
    fontSize: theme.typography.body2.fontSize
  };
});
const ValueBox = (0, _styles.styled)('div')(_ref2 => {
  let {
    theme
  } = _ref2;
  return {
    display: 'flex',
    padding: theme.spacing(1),
    border: 'solid 1px ' + theme.palette.border.gray,
    fontSize: theme.typography.body2.fontSize
  };
});

/**
 * 証跡ドキュメントラベルバリュー表示部品
 * @prop {string} [label] -ラベル部分に表示する内容
 * @prop {Array<{eviNo:(string|number), eviDocNm:string, fileNm:string}>} [value] -値部分（配列）
 * @prop {number} [labelWidth] -ラベル部分の幅
 */
const TrailDocumentValue = _ref3 => {
  let {
    label,
    value = [],
    labelWidth = 200
  } = _ref3;
  const createData = () => {
    const list = Array.isArray(value) ? value : [];
    return list.map(v => (v === null || v === void 0 ? void 0 : v.eviDocNm) || '').join('\n');
  };
  return /*#__PURE__*/_react.default.createElement(Container, null, /*#__PURE__*/_react.default.createElement(LabelBox, {
    style: {
      width: labelWidth
    }
  }, label), /*#__PURE__*/_react.default.createElement(ValueBox, {
    style: {
      width: "calc(100% - ".concat(labelWidth, "px)")
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    style: {
      whiteSpace: 'pre-line'
    }
  }, createData())));
};
exports.TrailDocumentValue = TrailDocumentValue;
TrailDocumentValue.propTypes = {
  label: _propTypes.default.string,
  value: _propTypes.default.arrayOf(_propTypes.default.shape({
    eviNo: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    eviDocNm: _propTypes.default.string,
    fileNm: _propTypes.default.string
  })),
  labelWidth: _propTypes.default.number
};
var _default = exports.default = (0, _reactIntl.injectIntl)((0, _CallAPI.withCallAPI)(TrailDocumentValue));